module.exports = __webpack_public_path__ + "img/sorteo.98518074.png";